import { Kpi, Section, money } from "./shared";

export default function CurrentPortfolioPosition({ data, currency }) {
  const metrics = data?.metrics || {};
  return <Section stage="Stage 1 — Understand Current Position" title="Current Position"><p className="mb-4 text-sm leading-6 text-slate-600">Expected Annual Loss is an annual mean; Current Capital at Risk is a distinct severe-loss capital measure. Neither should be read as the optimizer baseline unless explicitly labeled.</p><div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
    <Kpi label="Expected Annual Loss" value={money(metrics.eal?.baseline, currency)} />
    <Kpi label="Current Capital at Risk" value={money(metrics.capital_at_risk?.baseline, currency)} />
    <Kpi label="Active Scenarios" value={data?.summary?.scenario_count ?? "Not available"} />
    <Kpi label="Scenarios Outside Appetite" value={metrics.risk_appetite?.not_met_count ?? "Not available"} />
  </div></Section>;
}
